import {ISelectItem} from '../../../../../../shared/types';

export type AnalyzerTableData = {
  id: string;
  fieldName: string;
  analyzerName: string;
};

export const analyzerDropDownOptions: ISelectItem[] = [
  {
    id: '1',
    name: 'Consilo Standard Text',
  },
  {
    id: '2',
    name: 'Email/URL',
  },
  {
    id: '3',
    name: 'Path',
  },
  {
    id: '4',
    name: 'Consilio Standard CJK',
  },
];

// export const analyzerSelectionTableData: AnalyzerTableData[] = [
//   {id: '1', fieldName: 'caseNumber', analyzerName: 'Consilo Standard Text'},
//   {id: '2', fieldName: 'plaintiffName', analyzerName: 'Consilio Standard CJK'},
//   {id: '3', fieldName: 'defendantName', analyzerName: 'Consilio Standard CJK'},
//   {id: '4', fieldName: 'courtEmail', analyzerName: 'Email/URL'},
//   {id: '5', fieldName: 'documentPath', analyzerName: 'Path'},
//   {id: '6', fieldName: 'judgeName', analyzerName: 'Consilio Standard CJK'},
//   {id: '7', fieldName: 'legalArgument', analyzerName: 'Consilo Standard Text'},
//   {id: '8', fieldName: 'lawFirmWebsite', analyzerName: 'Email/URL'},
//   {
//     id: '9',
//     fieldName: 'documentLanguageCJK',
//     analyzerName: 'Consilio Standard CJK',
//   },
//   {id: '10', fieldName: 'caseSummary', analyzerName: 'Consilio Standard Text'},
// ];
